import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {

  @Input() title = '';
  @Input() header = '';
  @Input() showLogo = false;
  @Input() backButton = false;
  @Input() activeDot = 0;
  @Input() totalDots = 3;
  @Input() imageWidth = 120;
  @Input() walletType = '';

  public dotLengthArr = new Array(this.totalDots);
  public isDesktopMode;

  constructor(
    private navCtrl: NavController,
    private appMode: AppModeService,
    private modal: ModalController
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() { }

  goBack() {
    if (this.walletType == 'prime') {
      this.modal.dismiss();
      return;
    }
    this.navCtrl.back();
  }

}
